// extracted by mini-css-extract-plugin
export default {"submitButton":"iSRNUdnhcGSu1BTy5Tm9"};